import { RouteRecordRaw } from 'vue-router'

export default {
	path: '/setting',
	meta: {
		title: 'shared.setting'
	},
	component: {
		name: 'Setting',
		render() {
			return h(resolveComponent('router-view'))
		}
	},
	children: [
		{
			path: 'base-info',
			name: 'SettingBaseInfo',
			component: () => import('../pages/baseInfo.vue'),
			meta: {
				title: 'shared.baseInfo'
			}
		},
		{
			path: 'company-profile',
			meta: {
				title: 'shared.companyProfile'
			},
			children: [
				{
					path: '',
					name: 'CompanyProfile',
					component: () => import('../pages/companyProfile.vue')
				},
				{
					path: 'companies/:id',
					name: 'ShipperCompaniesDetail',
					component: () => import('../pages/companies/detail.vue'),
					meta: {
						title: 'shared.companyDetail',
						dynamicBreadcrumb: 'companyName'
					}
				},
				{
					path: 'users/detail',
					name: 'ShipperUsersDetail',
					component: () => import('../pages/users/detail.vue'),
					meta: {
						title: 'shared.createUser'
					}
				},
				{
					path: 'locations/detail',
					name: 'ShipperLocationsDetail',
					component: () => import('../pages/locations/detail.vue'),
					meta: {
						title: 'shared.createLocation'
					}
				},
				{
					path: 'users',
					component: {
						name: 'ShipperUsers',
						render() {
							return h(resolveComponent('router-view'))
						}
					},
					children: [
						{
							path: 'create',
							name: 'ShipperUsersCreate',
							component: () => import('../pages/users/detail.vue'),
							meta: {
								title: 'shared.createUser'
							}
						},
						{
							path: ':id',
							name: 'ShipperUsersDetail',
							component: () => import('../pages/users/detail.vue'),
							props: true,
							meta: {
								title: 'setting.userDetail',
								dynamicBreadcrumb: 'userName'
							}
						}
					]
				},
				{
					path: 'locations',
					component: {
						name: 'ShipperLocations',
						render() {
							return h(resolveComponent('router-view'))
						}
					},
					children: [
						{
							path: 'create',
							name: 'ShipperLocationsCreate',
							component: () => import('../pages/locations/detail.vue'),
							meta: {
								title: 'shared.createLocation'
							}
						},
						{
							path: ':id',
							name: 'ShipperLocationsDetail',
							component: () => import('../pages/locations/detail.vue'),
							props: true,
							meta: {
								title: 'setting.locationDetail',
								dynamicBreadcrumb: 'locationName'
							}
						}
					]
				}
			]
		}
	]
} as RouteRecordRaw
